import { types } from "@usher/pe-client-front-end-lib"
import { ClassValue, clsx } from "clsx"
import { AsYouType, parsePhoneNumberFromString } from "libphonenumber-js"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export const makeOption = (option: string[]) => option.map((opt) => ({ label: opt, value: opt }))

export const getFormattedPhone = (input: string) => {
  const parsedData = parsePhoneNumberFromString(input?.trimEnd() ?? "")
  if (parsedData == null) return { formatted: input?.trimEnd() ?? "", data: null }
  const formatter = new AsYouType(parsedData.country)
  return { formatted: formatter.input(input), data: parsedData }
}
const { STATUS_COMPLETED, STATUS_ERROR, STATUS_PENDING } = types.ExTransactionStatus
export const statusColors = (status: string) => {
  const statusName = status?.toLowerCase()
  if (statusName.includes("pending")) return "text-blue-500"
  if (statusName.includes("error")) return "text-red-500"
  if (["issued", "completed", "charged"].some((status) => statusName.includes(status))) return "text-green-500"
  return "text-gray-500"
}

export const getCurrencyLogoUrl = (currency: string) => {
  if (currency.startsWith("USDT")) return "usdt"
  if (currency.startsWith("USDC")) return "usdc"
  return currency.toLowerCase()
}

export const moneyFormat = (value: number, fixedCount: number = 2) => {
  return value.toLocaleString("en-US", {
    minimumFractionDigits: fixedCount,
    maximumFractionDigits: fixedCount,
  })
}
